var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCol',{attrs:{"sm":"6","md":"6"}},[_c('CCard',[_c('CCardHeader',[_c('h1',{staticClass:"display-6"},[_vm._v("La vidéo filmée par le capteur")])]),_c('CCardBody',[_c('img',{staticClass:"img-fluid",attrs:{"src":""}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }